const unitFactors = {
  ml: { type: "volume", factor: 1 },
  l: { type: "volume", factor: 1000 },
  g: { type: "mass", factor: 1 },
  kg: { type: "mass", factor: 1000 },
};

const parseNumber = (value) =>
  Number(String(value ?? "").trim().replace(",", "."));

const normalizeUnit = (value) => {
  const unit = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\./g, "");

  if (unit.startsWith("ml") || unit.startsWith("mililitro")) return "ml";
  if (unit.startsWith("kg") || unit.startsWith("quilograma")) return "kg";
  if (unit.startsWith("g") || unit.startsWith("grama")) return "g";
  if (unit.startsWith("l") || unit.startsWith("litro")) return "l";

  return null;
};

export const calculateProductQuantity = ({
  packageQuantity,
  packageCapacity,
  packageUnit,
  doseUnit,
}) => {
  const quantity = parseNumber(packageQuantity);
  const capacity = parseNumber(packageCapacity);
  const sourceUnit = normalizeUnit(packageUnit);
  const targetUnit = normalizeUnit(String(doseUnit || "").split("/")[0]);

  if (
    !Number.isFinite(quantity) ||
    !Number.isFinite(capacity) ||
    quantity <= 0 ||
    capacity <= 0 ||
    !sourceUnit ||
    !targetUnit ||
    unitFactors[sourceUnit].type !== unitFactors[targetUnit].type
  ) {
    return null;
  }

  const totalInBaseUnit =
    quantity * capacity * unitFactors[sourceUnit].factor;

  return totalInBaseUnit / unitFactors[targetUnit].factor;
};
